import { render, staticRenderFns } from "./SNavMenu.vue?vue&type=template&id=86b3db92&scoped=true&"
import script from "./SNavMenu.vue?vue&type=script&lang=ts&"
export * from "./SNavMenu.vue?vue&type=script&lang=ts&"
import style0 from "./SNavMenu.vue?vue&type=style&index=0&id=86b3db92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b3db92",
  null
  
)

export default component.exports